import * as React from "react";
import { UitkText } from "uitk-react-text";
import { ContentProps } from "../../../../typings";
import { decorateEditorialHtml } from "../../../../ContentUtilities";

export const CitifaqHeader = (props: ContentProps) => {
  const flexComponent = props.flexComponent;
  const model = flexComponent && flexComponent.model;
  const items = (model && model.items && model.items.filter((item) => item)) || [];

  if (items.length !== 1) {
    return null;
  }

  return (
    <div>
      <UitkText align="center" size={600} weight="bold">
        <div
          className="all-b-padding-six all-t-padding-twelve"
          dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)}
        />
      </UitkText>
    </div>
  );
};

export default CitifaqHeader;
